import { render } from "./PricesBlock.vue?vue&type=template&id=fb283b2a&scoped=true"
import script from "./PricesBlock.vue?vue&type=script&lang=js"
export * from "./PricesBlock.vue?vue&type=script&lang=js"

import "./PricesBlock.vue?vue&type=style&index=0&id=fb283b2a&lang=scss&scoped=true"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb283b2a"]])

export default __exports__